(function (pmw, undefined) {

	const PMW_LIBRARY_VERSION = "1.65.1"

	/**
	 * The pmwDataLayer schema version this library understands. Must match
	 * PMW_DATA_LAYER_SCHEMA_VERSION on the PHP side. Bumped manually, and
	 * only for BREAKING data layer changes; additive changes never bump it.
	 * A bump ships together with docs/schema/pmw-datalayer.schema.json, the
	 * fixtures, and the payload snapshots. See docs/PLATFORM-CONTRACT.md.
	 */
	const PMW_SCHEMA_VERSION = 1

	pmw.getLibraryVersion = () => {
		return PMW_LIBRARY_VERSION
	}

	pmw.getSchemaVersion = () => {
		return PMW_SCHEMA_VERSION
	}

	pmw.checkLibraryVersion = () => {

		if (pmw.getLibraryVersion() !== pmwDataLayer?.version?.number) {
			console.error(`Pixel Manager: The library version ${pmw.getLibraryVersion()} and pmwDataLayer.version.number ${pmwDataLayer.version.number} do not match. Delete the server-side cache and try again.`)
		}

		pmw.checkSchemaVersion()
	}

	/**
	 * Compare the data layer's schema version against the library's.
	 *
	 * - dataLayer NEWER than library: the server emits a shape this library
	 *   cannot fully read. Hard error + pmw:error:schema-mismatch bus event
	 *   so platform harnesses can report it.
	 * - dataLayer OLDER or missing: tolerated (schema bumps are breaking on
	 *   the emitting side, the library stays backward-compatible by policy);
	 *   a console warning aids diagnosis of stale caches.
	 */
	pmw.checkSchemaVersion = () => {

		const dataLayerSchema = pmwDataLayer?.version?.schema

		if (typeof dataLayerSchema === "undefined") {
			console.warn("Pixel Manager: The pmwDataLayer carries no schema version. The server side is probably older than the library; if tracking misbehaves, delete the server-side cache.")
			return
		}

		if (dataLayerSchema > PMW_SCHEMA_VERSION) {
			console.error(`Pixel Manager: The pmwDataLayer schema version ${dataLayerSchema} is newer than the library's (${PMW_SCHEMA_VERSION}). The tracking library is too old for this server; delete all caches, and if the mismatch persists, reinstall the plugin.`)
			pmw.bus.emit("pmw:error:schema-mismatch", {
				dataLayer: dataLayerSchema,
				library  : PMW_SCHEMA_VERSION,
			})
			return
		}

		if (dataLayerSchema < PMW_SCHEMA_VERSION) {
			console.warn(`Pixel Manager: The pmwDataLayer schema version ${dataLayerSchema} is older than the library's (${PMW_SCHEMA_VERSION}). Probably a stale server-side cache; the library stays backward-compatible.`)
		}
	}

}(window.pmw = window.pmw || {}))

